import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <section className="bg-navy px-4 py-16 sm:py-24" aria-labelledby="bonus-title" data-id="element-74" data-mp="aua4y8rf39qx">
      <div className="mx-auto max-w-3xl" data-id="element-75" data-mp="ft4q3hcuxae7">
        <div className="flex justify-center" data-id="element-76" data-mp="fs3ftf3o0rxj">
          <span className="inline-flex items-center gap-2 rounded-full bg-gold px-4 py-1.5 text-xs font-extrabold uppercase tracking-widest text-navy" data-id="element-77" data-mp="1u5a0y3eu3tn">
            <GiftIcon aria-hidden="true" className="h-4 w-4" data-id="element-78" data-mp="5tnkezxluwi8" /> Today only
          </span>
        </div>
        <div id="bonus-title" className="mt-4" data-id="element-79" data-mp="3o3y73wkwza9p">
          <SectionHeading tone="dark" title={<>5 Exclusive Bonuses — <span className="italic text-gold-light" data-id="element-81" data-mp="1m9qkhnrbhvnx">Included FREE</span></>} intro={<>Total stated bonus value: <strong className="text-white" data-id="element-82" data-mp="1r8a59ku6d1ep">$147 USD</strong> — included free with your purchase.</>} data-id="element-80" data-mp="3t1r8mcb9vg3n" />
        </div>

        <ol className="mt-10 space-y-8" data-id="element-83" data-mp="3icvejinyew53">
          {bonuses.map(b => <li key={b.number} className="overflow-hidden rounded-3xl bg-white" data-id="element-84" data-mp="3deadjh0vo8fl">
              <div className="flex items-center justify-between gap-3 bg-gold px-5 py-3" data-id="element-85" data-mp="3r79pxa5d5mix">
                <span className="text-sm font-extrabold uppercase tracking-widest text-navy" data-id="element-86" data-mp="3n5enu3flz543">Bonus #{b.number}</span>
                <span className="text-sm font-bold text-navy" data-id="element-87" data-mp="2zeskuqkgob0y">
                  <span className="line-through opacity-70" data-id="element-88" data-mp="2ugh92aalvqg3">${b.value}</span> · FREE today
                </span>
              </div>
              <img src={b.image} alt={b.title} className="block h-auto w-full bg-white" loading="lazy" data-id="element-89" data-mp="38gil8lwbmkav" />
              <div className="px-5 pb-6 pt-2 sm:px-7" data-id="element-90" data-mp="33gw4w3l74nxu">
                <h3 className="font-serif text-2xl font-extrabold leading-tight text-navy" data-id="element-91" data-mp="33jiee8rnddip">{b.title}</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-ink-muted" data-id="element-92" data-mp="iqyhubzbel0a">{b.text}</p>
                <ul className="mt-4 space-y-2" data-id="element-93" data-mp="itauqaq7u56h">
                  {b.bullets.map(x => <li key={x} className="flex gap-2.5 text-[15px] leading-snug text-navy" data-id="element-94" data-mp="3cl0w9ayngol0">
                      <CheckIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} data-id="element-95" data-mp="3hk404s2w8ore" />
                      <span data-id="element-96" data-mp="3lhru9swridi8">{x}</span>
                    </li>)}
                </ul>
              </div>
            </li>)}
        </ol>

        <div className="mt-12 [&_p]:text-white/70" data-id="element-97" data-mp="2ttzvqihvskzc">
          <CtaButton label="Yes, I Want All 5 Bonuses Free" data-id="element-98" data-mp="2xtqsd2u39vbs" />
        </div>
      </div>
    </section>;
}